import { ACTION } from '@cvent/react-analytics';

export const notificationDelivered = {
  id: 'notification_delivered',
  name: 'Notification delivered',
  type: ACTION,
  attributes: ['notificationDelivered'],
  destinations: ['Analytics'],
  objectIdAttribute: 'notificationId'
};

export const notificationClicked = {
  id: 'notification_clicked',
  name: 'Notification clicked',
  type: ACTION,
  attributes: ['notificationId', 'hasLinkedContent', 'contentType', 'content', 'isClickedFromPush'],
  destinations: ['Analytics'],
  objectIdAttribute: 'notificationId'
};

export const notificationRead = {
  id: 'notification_read',
  name: 'Notification read',
  type: ACTION,
  attributes: ['notificationIds', 'isRead'],
  destinations: ['Analytics'],
  objectIdAttribute: 'notificationId'
};
